import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { Revisione53DatiBusinessSelectors } from '../../../../store/selectors/dati-business.selectors';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { getControl } from '@shared/helpers/form.helper';
import { cloneDeep } from 'lodash-es';
import { MySpdElemConsiglioGestioneEntity, MySpdElemConsiglioSorveglianzaEntity, MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { controlloCheckConsiglioSorveglianza } from '../../common/helpers/norme-spa-helpers.helper';
import { getSpdConsiglioGestioneArray, getSpdConsiglioSorveglianzaArray } from '../validators/helpers/norme-spa-dualistico-form-validators.helper';
import { withCkNormeGuard } from '../../common/operators/with-ck-norme-guard.operator';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';

export const setNormeSpaDualisticoConsiglioListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_SpdElemConsiglioSorveglianza(form, store);
    my_SpdElemConsiglioGestione(form, store);
};

const my_SpdElemConsiglioSorveglianza = (form: FormGroup, store: Store<Revisione53State>): void => {
    const componentiConsiglioSorveglianzaArray = getSpdConsiglioSorveglianzaArray(form);

    componentiConsiglioSorveglianzaArray.valueChanges
        // Guard: senza, l'array vuoto di un verbale non dualistico riscriveva my_ControlloRevLegali = '0' sullo store.
        .pipe(withChangeDebounced(componentiConsiglioSorveglianzaArray), withCkNormeGuard(form, CkNormeValuesEnum.normeSpaDualistico))
        .subscribe((componentiConsiglioSorveglianza: MySpdElemConsiglioSorveglianzaEntity[] = []) => {
            controlloCheckConsiglioSorveglianza(form, store, componentiConsiglioSorveglianza);

            componentiConsiglioSorveglianza.forEach((componenteConsiglioSorveglianza, index) => {
                const codiceCarica = componenteConsiglioSorveglianza.my_SpdConsSorvCarica;

                store
                    .select(Revisione53DatiBusinessSelectors.getSpdConsSorvCaricaSpec(codiceCarica))
                    .pipe(take(1))
                    .subscribe((carica) => {
                        const componenteConsiglioSorveglianzaGroup = componentiConsiglioSorveglianzaArray.at(index) as FormGroup;
                        const descrizioneCaricaControl = getControl(componenteConsiglioSorveglianzaGroup, 'my_SpdConsSorvCaricaDesc');

                        descrizioneCaricaControl.patchValue(carica?.descrizione ?? '', {
                            emitEvent: false,
                        });

                        updateVerbaleOnStore(store, (myVerbale) => {
                            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                            const spd = myVerbaleClone.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSpaDualistico;
                            spd.my_SpdConsiglioSorveglianza.my_SpdElemConsiglioSorveglianza = componentiConsiglioSorveglianzaArray.value;
                            return myVerbaleClone;
                        });
                    });
            });
        });
};

const my_SpdElemConsiglioGestione = (form: FormGroup, store: Store<Revisione53State>): void => {
    const componentiConsiglioGestioneArray = getSpdConsiglioGestioneArray(form);

    componentiConsiglioGestioneArray.valueChanges
        .pipe(withChangeDebounced(componentiConsiglioGestioneArray))
        .subscribe((componentiConsiglioGestione: MySpdElemConsiglioGestioneEntity[] = []) => {
            componentiConsiglioGestione.forEach((componenteConsiglioGestione, index) => {
                const codiceCarica = componenteConsiglioGestione.my_SpdConsGestCarica;

                store
                    .select(Revisione53DatiBusinessSelectors.getSpdConsGestCaricaSpec(codiceCarica))
                    .pipe(take(1))
                    .subscribe((carica) => {
                        const componenteConsiglioGestioneGroup = componentiConsiglioGestioneArray.at(index) as FormGroup;
                        const descrizioneCaricaControl = getControl(componenteConsiglioGestioneGroup, 'my_SpdConsGestCaricaDesc');

                        descrizioneCaricaControl.patchValue(carica?.descrizione ?? '', {
                            emitEvent: false,
                        });

                        updateVerbaleOnStore(store, (myVerbale) => {
                            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                            const spd = myVerbaleClone.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSpaDualistico;
                            spd.my_SpdConsiglioGestione.my_SpdElemConsiglioGestione = componentiConsiglioGestioneArray.value;
                            return myVerbaleClone;
                        });
                    });
            });
        });
};
